"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiedReviewLabelFontSize = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CheckmarkRounded_1 = __importStar(require("../../Icons/CheckmarkRounded/CheckmarkRounded"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var Typography_1 = __importStar(require("../../Typography/Typography"));
var VerifiedReviewLabelFontSize;
(function (VerifiedReviewLabelFontSize) {
    VerifiedReviewLabelFontSize["small"] = "small";
    VerifiedReviewLabelFontSize["default"] = "default";
})(VerifiedReviewLabelFontSize = exports.VerifiedReviewLabelFontSize || (exports.VerifiedReviewLabelFontSize = {}));
var VerifiedReviewLabelElement = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var VerifiedReviewLabel = function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? VerifiedReviewLabelFontSize.default : _b, text = _a.text, rest = __rest(_a, ["fontSize", "text"]);
    return (react_1.default.createElement(VerifiedReviewLabelElement, __assign({ "data-testid": 'verified-review-label' }, rest),
        react_1.default.createElement(CheckmarkRounded_1.default, { color: CheckmarkRounded_1.IconColorThemes.default, size: fontSize === VerifiedReviewLabelFontSize.small
                ? b2c_theme_1.IconSizes.xSmall
                : b2c_theme_1.IconSizes.small }),
        react_1.default.createElement(Typography_1.default, { "data-testid": 'verified-review-label-text', component: "span", variant: fontSize === VerifiedReviewLabelFontSize.small
                ? Typography_1.TypeVariants.bodySmall
                : Typography_1.TypeVariants.body, theme: 'secondary', margin: fontSize === VerifiedReviewLabelFontSize.small
                ? '0 0 0 .4rem'
                : '0 0 0 .8rem' }, text)));
};
exports.default = VerifiedReviewLabel;
var templateObject_1;
//# sourceMappingURL=VerifiedReviewLabel.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Labels/VerifiedReviewLabel/VerifiedReviewLabel.js
// module id = 1764
// module chunks = 5 16 19